import React from 'react'
import { ThemeProvider } from '@src/theme'
import { ToastContainer } from 'react-toastify'
import Router from './routes/sections'
import { SettingsProvider } from './components/settings'

const App: React.FC = () => {
  return (
    <SettingsProvider
      defaultSettings={{
        themeMode: 'light', // 'light' | 'dark'
        themeDirection: 'ltr', //  'rtl' | 'ltr'
        themeContrast: 'default', // 'default' | 'bold'
        themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
        themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
        themeStretch: false,
      }}
    >
      <ThemeProvider>
        <ToastContainer autoClose={2000} />
        <Router />
      </ThemeProvider>
    </SettingsProvider>
  )
}

export default App
